import React from 'react';
import { Link } from 'react-router-dom';
export function Footer() {
  return <footer className="bg-[#050b14] border-t border-white/10 pt-16 pb-8" data-id="element-289">
      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-290">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16" data-id="element-291">
          {/* Brand Column */}
          <div data-id="element-292">
            <div className="flex items-center gap-2 mb-6" data-id="element-293">
              <div className="bg-[#d4a853] text-[#0a1628] font-bold text-2xl px-3 py-1.5 rounded" data-id="element-294">
                888
              </div>
              <div className="text-white font-bold text-sm uppercase tracking-wider" data-id="element-295">
                Sourcing
                <br data-id="element-296" />
                Limited
              </div>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed" data-id="element-297">
              Professional product sourcing and market development company
              connecting manufacturers with leading hypermarkets, supermarket
              chains, and retail distributors across the UK, Europe, and Asia.
            </p>
          </div>

          {/* Services */}
          <div data-id="element-298">
            <h4 className="text-white font-bold uppercase tracking-wider mb-6" data-id="element-299">
              Services
            </h4>
            <ul className="space-y-3 text-sm text-gray-400" data-id="element-300">
              <li data-id="element-301">Product Sourcing</li>
              <li data-id="element-302">Manufacturer Representation</li>
              <li data-id="element-303">Market Entry</li>
              <li data-id="element-304">Procurement Management</li>
              <li data-id="element-305">Product Promotion</li>
            </ul>
          </div>

          {/* Regions */}
          <div data-id="element-306">
            <h4 className="text-white font-bold uppercase tracking-wider mb-6" data-id="element-307">
              Regions
            </h4>
            <ul className="space-y-3 text-sm text-gray-400" data-id="element-308">
              <li data-id="element-309">United Kingdom</li>
              <li data-id="element-310">France & EU</li>
              <li data-id="element-311">Germany</li>
              <li data-id="element-312">Asia & Middle East</li>
              <li data-id="element-313">Global</li>
            </ul>
          </div>

          {/* Legal/Contact */}
          <div data-id="element-314">
            <h4 className="text-white font-bold uppercase tracking-wider mb-6" data-id="element-315">
              Legal
            </h4>
            <ul className="space-y-3 text-sm text-gray-400" data-id="element-316">
              <li data-id="element-317">
                <Link to="/privacy-policy" className="hover:text-[#d4a853] transition-colors" data-id="element-318">
                  Privacy Policy
                </Link>
              </li>
              <li data-id="element-319">
                <Link to="/terms-of-service" className="hover:text-[#d4a853] transition-colors" data-id="element-320">
                  Terms of Service
                </Link>
              </li>
              <li data-id="element-321">
                <Link to="/cookie-policy" className="hover:text-[#d4a853] transition-colors" data-id="element-322">
                  Cookie Policy
                </Link>
              </li>
              <li data-id="element-323">
                <Link to="/sitemap" className="hover:text-[#d4a853] transition-colors" data-id="element-324">
                  Sitemap
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-325">
          <p className="text-gray-500 text-xs" data-id="element-326">
            © {new Date().getFullYear()} 888 Sourcing Limited. All rights
            reserved.
          </p>
          <p className="text-gray-500 text-xs" data-id="element-327">
            Connecting manufacturers with global retail markets.
          </p>
        </div>
      </div>
    </footer>;
}